/* eslint-disable indent */
import { createContext, useContext } from "react";

import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { BASE_URL } from "../env";
import useHandleServerMessage from "../Helpers/HandleServerMessage";
import { SnackContext } from "./SnackContext";

export const ApiContext = createContext();

export const ApiProvider = ({ children }) => {
	const navigate = useNavigate();
	const location = useLocation();
	const handleServerMessage = useHandleServerMessage(); // fixes invalid hook call breaking rules for hooks...

	const { showSnackMessage } = useContext(SnackContext);

	const ApiCall = (method, url, body) =>
		new Promise((resolve, reject) => {
			let token = document.cookie.split("webapp-token=")[1];

			// Debug mode: log route and token
			if (process.env.NODE_ENV === "development") {
				console.debug("API Method:", method, url);
			}

			if (
				token === undefined &&
				url !== "user" &&
				url !== "login" &&
				url !== "user/reset_password" &&
				url !== "code_login"
			) {
				navigate("/login");
				return;
			} // Jos tokenia ei ole, estetään kaikki muut pyynnöt paitsi sisäänkirjautuminen, salasanan palautus ja user vanhan tokenin varmistamista varten

			if (token !== undefined) token = token.split(";")[0];

			const splitted_url = url.split("/");

			let route = "";

			for (let i = 0; i < splitted_url.length; i++) {
				let isnum = /^\d+$/.test(splitted_url[i]);
				if (!isnum)
					route = route + (i !== 0 ? "_" : "") + splitted_url[i];
			}

			axios({
				method,
				url: BASE_URL + url,

				data: body,
				headers: {
					Authorization: "Bearer " + token
				}
			})
				.then((res) => {
					if (method !== "GET") showSnackMessage(route, res.status);
					resolve(res.data);
				})
				.catch((err) => {
					if (location.pathname === "/login") return reject(err); // don't show snackbar messages on login screen

					if (err.response === undefined) {
						console.log("response undefined");
						showSnackMessage("general", 0);
						reject(err);
						return;
					}

					document.cookie = "";

					if (method !== "GET")
						showSnackMessage(route, err.response.status);
					else showSnackMessage("general", err.response.status);
					// erase cookies and route to login if status code is 401
					// navigate("/login");
					if (
						err.response.status === 401 &&
						navigate !== null
					) {
						document.cookie =
							"webapp-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
						navigate("/login");
						showSnackMessage("general", err.response.status);
						return; // Don't reject the promise, should prevent browser error overlay from showing
					}

					// Checks for error message from server and returns translation if found
					const errorMessage = handleServerMessage(
						err.response.data.error
					);

					reject(errorMessage);
				});
		});

	return (
		<ApiContext.Provider
			value={{
				ApiCall
			}}
		>
			{children}
		</ApiContext.Provider>
	);
};
